var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.valid || _vm.fallbackSrc)?_c('div',{class:[
    _vm.$style.zoomImage,
    ( _obj = {}, _obj[_vm.$style.allowZoom] = _vm.valid && _vm.allowZoom, _obj ),
    ( _obj$1 = {}, _obj$1[_vm.$style.zooming] = _vm.openZoom, _obj$1 )
  ]},[_c('img',{class:_vm.$style.mainImage,attrs:{"src":_vm.valid ? _vm.src : _vm.fallbackSrc,"alt":_vm.alt,"title":_vm.title},on:{"click":function($event){$event.stopPropagation();return _vm.handleImageClick($event)},"error":_vm.handleInvalidImage}}),_vm._v(" "),(_vm.valid && _vm.allowZoom)?_c('Lightbox',{attrs:{"open":_vm.openZoom},on:{"close":_vm.handleCloseZoom}},[_c('img',{class:_vm.$style.lightboxImage,attrs:{"src":_vm.src}})]):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }